/**
 * @file Import button for the plain JSON (ID-based) format.
 */

import { UploadOutlined } from '@ant-design/icons';
import { Button, Tooltip, Upload } from 'antd';
import React from 'react';
import { importPlainJson } from '../controller/import-export-plain';
import { useReducerProps } from './App';

const dummyRequest = ({ onSuccess }: any) => {
  setTimeout(() => {
    onSuccess('ok');
  }, 0);
};

const ImportPlainJsonButton: React.FC<useReducerProps> = ({ dispatch }) => {
  const onChange = (evt: any) => {
    if (evt.file.status === 'done') {
      const file = evt.file.originFileObj;
      const reader = new FileReader();
      reader.onload = function () {
        importPlainJson(reader.result, dispatch);
      };
      reader.readAsText(file);
    }
  };

  return (
    <Upload
      customRequest={dummyRequest}
      showUploadList={false}
      onChange={onChange}
    >
      <Tooltip placement="bottomLeft" title={'Import plain json'}>
        <Button
          className="export-button"
          icon={<UploadOutlined />}
          size="large"
        />
      </Tooltip>
    </Upload>
  );
};

export default ImportPlainJsonButton;
